import type cytoscape from 'cytoscape'

import type { Feature } from '../../feature'
import type * as models from '../../models'

/**
 * Sets it up so that the panel to edit nodes is opened as soon as the node is
 * selected
 */
export function setupEditOnSelect(
  cy: cytoscape.Core,
  { feature, orgChartId }: setupEditOnSelect.AdditionalParams,
) {
  cy.on('select', 'node', event => {
    const selectedNode = event.target as cytoscape.NodeSingular
    // NOTE: this will automatically use the now selected node ID
    feature.actions.editNode
      .from('Cytoscape.Node.Select')
      .dispatch({ id: selectedNode.id(), orgChartId })
  })
}
export namespace setupEditOnSelect {
  export interface AdditionalParams extends models.OrgChart.Identifier {
    readonly feature: Feature
  }
}
